import * as moment from 'moment';


//NOT USED

export class FilterArrayValueConverter {
    toView(array, filterFunc) {
        return filterFunc(array);
    }
}